/**
 * HTTP header that the dashboard uses to tag API requests with the originating product
 * (Platform vs Connect). Mirrored onto Clerk publicMetadata + the Mongo organization document
 * during sync. The lowercase variant matches what Node/Express expose on `req.headers`.
 */
export const NOVU_PRODUCT_TYPE_HEADER = 'X-Novu-Product-Type';
export const NOVU_PRODUCT_TYPE_HEADER_LOWERCASE = 'x-novu-product-type';
export var ApiServiceLevelEnum;
(function (ApiServiceLevelEnum) {
    ApiServiceLevelEnum["FREE"] = "free";
    ApiServiceLevelEnum["PRO"] = "pro";
    ApiServiceLevelEnum["BUSINESS"] = "business";
    ApiServiceLevelEnum["ENTERPRISE"] = "enterprise";
    ApiServiceLevelEnum["UNLIMITED"] = "unlimited";
})(ApiServiceLevelEnum || (ApiServiceLevelEnum = {}));
export var StripeBillingIntervalEnum;
(function (StripeBillingIntervalEnum) {
    StripeBillingIntervalEnum["MONTH"] = "month";
    StripeBillingIntervalEnum["YEAR"] = "year";
})(StripeBillingIntervalEnum || (StripeBillingIntervalEnum = {}));
export var ProductUseCasesEnum;
(function (ProductUseCasesEnum) {
    ProductUseCasesEnum["IN_APP"] = "in_app";
    ProductUseCasesEnum["MULTI_CHANNEL"] = "multi_channel";
    ProductUseCasesEnum["DELAY"] = "delay";
    ProductUseCasesEnum["TRANSLATION"] = "translation";
    ProductUseCasesEnum["DIGEST"] = "digest";
})(ProductUseCasesEnum || (ProductUseCasesEnum = {}));
export var IndustryEnum;
(function (IndustryEnum) {
    IndustryEnum["ECOMMERCE"] = "ecommerce";
    IndustryEnum["FINTECH"] = "fintech";
    IndustryEnum["SAAS"] = "saas";
    IndustryEnum["HEALTHCARE"] = "healthcare";
    IndustryEnum["EDUCATION"] = "education";
    IndustryEnum["MEDIA"] = "media";
    IndustryEnum["MARKETPLACE"] = "marketplace";
    IndustryEnum["GAMING"] = "gaming";
    IndustryEnum["TRAVEL"] = "travel";
    IndustryEnum["REAL_ESTATE"] = "real_estate";
    IndustryEnum["LOGISTICS"] = "logistics";
    IndustryEnum["FOOD_AND_BEVERAGE"] = "food_and_beverage";
    IndustryEnum["INSURANCE"] = "insurance";
    IndustryEnum["GOVERNMENT"] = "government";
    IndustryEnum["NON_PROFIT"] = "non_profit";
    IndustryEnum["TELECOMMUNICATIONS"] = "telecommunications";
    IndustryEnum["RETAIL"] = "retail";
    IndustryEnum["AUTOMOTIVE"] = "automotive";
    IndustryEnum["CONSTRUCTION"] = "construction";
    IndustryEnum["ENERGY"] = "energy";
    IndustryEnum["AGRICULTURE"] = "agriculture";
    IndustryEnum["LEGAL"] = "legal";
    IndustryEnum["OTHER"] = "other";
})(IndustryEnum || (IndustryEnum = {}));
/**
 * Distinguishes the two Novu products that share the same Clerk tenant and dashboard build.
 * Stored on Clerk `publicMetadata.productType` and mirrored on the MongoDB organization document.
 * Treat a missing value as `PLATFORM` so existing tenants keep working without backfill.
 */
export var OrganizationProductTypeEnum;
(function (OrganizationProductTypeEnum) {
    OrganizationProductTypeEnum["PLATFORM"] = "platform";
    OrganizationProductTypeEnum["CONNECT"] = "connect";
})(OrganizationProductTypeEnum || (OrganizationProductTypeEnum = {}));
/**
 * Reads `productType` from a metadata bag without applying a default. Returns the explicit
 * enum value when present and recognized, otherwise `undefined`. Use this when the caller
 * needs to distinguish "missing metadata" (typically a freshly-created org whose backend
 * sync hasn't landed yet) from an explicit Platform/Connect value.
 */
export function tryReadOrganizationProductType(metadata) {
    const value = metadata && typeof metadata === 'object' ? metadata.productType : null;
    if (value === OrganizationProductTypeEnum.CONNECT) {
        return OrganizationProductTypeEnum.CONNECT;
    }
    if (value === OrganizationProductTypeEnum.PLATFORM) {
        return OrganizationProductTypeEnum.PLATFORM;
    }
    return undefined;
}
/**
 * Reads `productType` and applies the `PLATFORM` default for backwards compatibility with
 * existing tenants. Prefer `tryReadOrganizationProductType` in any UX path where defaulting
 * to Platform could trigger a redirect or hide a fresh-but-not-yet-synced org.
 */
export function resolveOrganizationProductType(metadata) {
    return tryReadOrganizationProductType(metadata) ?? OrganizationProductTypeEnum.PLATFORM;
}
//# sourceMappingURL=organization.js.map